(function () {
  if (window.__freeShippingBarInit) return;
  window.__freeShippingBarInit = true;

  var THRESHOLD_CENTS = 7500;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function message(totalCents, itemCount) {
    if (itemCount === 0) {
      return { hide: true };
    }
    if (totalCents >= THRESHOLD_CENTS) {
      var unlockedText = "You've unlocked FREE shipping!";
      if (itemCount >= 4) unlockedText += ' + 20% off';
      return { hide: false, text: unlockedText, pct: 100 };
    }
    var remaining = THRESHOLD_CENTS - totalCents;
    var pct = Math.max(0, Math.min(100, Math.round((totalCents / THRESHOLD_CENTS) * 100)));
    var text;
    if (itemCount === 3) {
      text = 'So close — add 1 more item for FREE shipping AND your 20% bundle discount';
    } else if (itemCount === 2) {
      text = "You're " + money(remaining) + ' away from FREE shipping. Add one more to get close.';
    } else if (itemCount === 1) {
      text = "You're " + money(remaining) + ' away from FREE shipping — most shoppers get there with 4 items';
    } else {
      text = "You're " + money(remaining) + " away from FREE shipping — you've already unlocked 20% off with 4+ items";
    }
    return { hide: false, text: text, pct: pct };
  }

  function render(totalCents, itemCount) {
    var nodes = document.querySelectorAll('[data-free-shipping-bar]');
    if (!nodes.length) return;
    var m = message(totalCents, itemCount);
    nodes.forEach(function (node) {
      if (m.hide) {
        node.classList.add('is-hidden');
        return;
      }
      node.classList.remove('is-hidden');
      var textEl = node.querySelector('[data-free-shipping-bar-text]');
      var fillEl = node.querySelector('[data-free-shipping-bar-fill]');
      if (textEl) textEl.textContent = m.text;
      if (fillEl) fillEl.style.width = m.pct + '%';
    });
  }

  function refreshFromServer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price, cart.item_count); });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var cartData = event && event.cartData;
        if (cartData && typeof cartData.total_price === 'number' && typeof cartData.item_count === 'number') {
          render(cartData.total_price, cartData.item_count);
        } else {
          refreshFromServer();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
